import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import './GenericNotFound.css'
import autommateTransparentLogo from '../../../assets/Images/image.png'
import { useTranslation } from 'react-i18next'

function GenericNotFound() {
    const history = useNavigate()
    const {t} = useTranslation()

    useEffect(()=> {
        setTimeout(()=> {
           history('/settings/license')
        }, 5000)
    })

    return (
        <div className='not-found-container' data-test='component'>
            <div className='title color'>
                {t('CONTENT.404.TITLE')}
            </div>
            <div className= 'subTitle color'>
                {t('CONTENT.404.SUB-TITLE')}
            </div>
            <div className= 'subTitle color'>
                {t('CONTENT.404.SUB-TITLE-2')}
            </div>
            <button onClick={() =>{window.location.href='/'}} className='go-home-button' >
               {t('CONTENT.404.GO-HOME')}
            </button>
            <img className='image' src={autommateTransparentLogo} alt="autommate-transparent-logo"/>
        </div>
    )
}

export default GenericNotFound
